<template>
  <custom-callout border-color-hex="#FB7058" class="mb-4" :has-toggle="false">
    <icon-view
      class="mt-2"
      icon="fa fa-file-invoice-dollar mb-1"
      icon-background="#ff745c"
      icon-color="#fff"
      icon-size="14px"
      title="Asignar Presupuesto"
    />
    <validation-observer ref="budgetManagementRef" novalidate tag="form">
      <div class="row mt-3 mr-3">
        <div class="col-md-4 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">Año académico:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ddlAcademicYear"
              v-model="model.academicYear"
              :clearable="false"
              custom-error-msg="El año académico es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="academicYears"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">Cantidad:</div>
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'La cantidad es requerida.',
              greaterThanZero: 'La cantidad debe ser mayor que 0.',
            }"
            rules="required|greaterThanZero"
          >
            <custom-input
              id="txtQuantity"
              v-model="model.amount"
              :error="errors[0]"
              icon-background-class="add-icon-background"
              placeholder="$0.00"
              :prepend-icon="'fas fa-dollar-sign dollar-icon'"
              :prepend-icon-left="true"
              type="number"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 mt-3 d-flex justify-content-end align-items-start">
          <action-button
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger m-2 px-4"
            @click="onCancelHandler"
          />
          <action-button
            i="fas fa-save"
            text="Guardar"
            variant="success m-md-2 px-4"
            @click="onSaveHandler"
          />
        </div>
        <div class="col-md-12 m-3" />
      </div>
    </validation-observer>
  </custom-callout>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { getAcademicYearsWithoutBudget } from '@/views/support/modules/shared/budget.api.js';

export default {
  name: 'BudgetManagementServices',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    ActionButton,
    IconView,
    CustomInput,
    CustomDropDown,
  },
  data: () => ({
    model: {
      academicYear: null,
      amount: null,
    },
    academicYears: [],
  }),
  async mounted() {
    await getAcademicYearsWithoutBudget().then(
      ({ data }) => (this.academicYears = data)
    );
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onSaveHandler() {
      const isValid = await this.$refs.budgetManagementRef.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      this.$emit('on-save', { ...this.model });
    },
  },
};
</script>

<style scopped>
.add-icon-background {
  background-color: var(--green);
}

.dollar-icon {
  color: var(--white);
  font-weight: 400;
}
</style>
